<section class="fixed !z-[999999999999999999999999999] flex items-end w-screen h-screen top-0 right-0 pointer-events-none">
<section class="w-full h-full">
    @if (allToast['top-r'].length) {
    <div class="absolute top-16 inset-x-2 sm:inset-x-auto sm:right-4 flex flex-col pointer-events-auto">
        <div [@fadeButton] class="flex flex-col gap-5 bg-black/2 backdrop-blur-sm rounded-xl">
            <div class="flex justify-end gap-2">
                <button (click)="markAllAsRead()"
                    class="flex w-fit items-center justify-center bg-mg-main-blue-dark text-white gap-1 px-2 py-1 rounded-full p-2 lg:rounded-lg hover:opacity-80 transition-opacity">
                    <mg-icon iconName="done_all" [iconClass]="'text-lg'"></mg-icon>
                    <span class="lg:inline hidden">Marcar todos como leídos</span>
                </button>
                <button (click)="closeAllNotifications()"
                    class="flex w-fit items-center justify-center bg-mg-main-blue-dark text-white gap-1 px-2 py-1 rounded-full p-2 lg:rounded-lg hover:opacity-80 transition-opacity">
                    <mg-icon iconName="notifications_off" [iconClass]="'text-lg'"></mg-icon>
                    <span class="lg:inline hidden">Cerrar</span>
                </button>
            </div>
            @for (toast of allToast['top-r']; track toast.count) {
            <div class="flex flex-col gap-4">
                <mg-toast-alert [toastData]="toast" (toastClosed)="onToastClosed($event)"></mg-toast-alert>
            </div>
            }
        </div>
    </div>
    }
    @if (allToast['top-l'].length) {
    <div class="absolute top-16 inset-x-2 sm:inset-x-auto sm:top-4 sm:left-4 flex flex-col gap-5">
        @for (toast of allToast['top-l']; track toast.count) {
        <div class="flex flex-col gap-4 pointer-events-auto">
            <mg-toast-alert [toastData]="toast" (toastClosed)="onToastClosed($event)"></mg-toast-alert>
        </div>
        }
    </div>
    }
    @if (allToast['bottom-r'].length) {
    <div class="absolute flex flex-col-reverse gap-5 bottom-4 inset-x-2 sm:inset-x-auto sm:right-4">
        @for (toast of allToast['bottom-r']; track toast.count) {
        <div class="flex flex-col gap-4 pointer-events-auto">
            <mg-toast-alert [toastData]="toast" (toastClosed)="onToastClosed($event)"></mg-toast-alert>
        </div>
        }
    </div>
    }
    @if (allToast['bottom-l'].length) {
    <div class="absolute flex flex-col-reverse gap-5 bottom-4 inset-x-2 sm:inset-x-auto sm:left-4">
        @for (toast of allToast['bottom-l']; track toast.count) {
        <div class="flex flex-col gap-4 pointer-events-auto">
            <mg-toast-alert [toastData]="toast" (toastClosed)="onToastClosed($event)"></mg-toast-alert>
        </div>
        }
    </div>
    }
</section>
</section>
